// Lib
import React from 'react';
import SliderSlick from 'react-slick';
import { Typography } from '@mui/material';

// Components
import Button from '../Button';
import Feather from '../Feather';

// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Styles
import { useStyles } from './SliderStyles';

const PrevArrow = ({ className, style, onClick }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      className={cx(className, classes.buttonArrow, classes.arrowSurface)}
      // eslint-disable-next-line react/forbid-component-props -- runtime geometry from react-slick
      style={style}
      onClick={onClick}>
      <Feather printType="stroke" type="arrowSlideLeft" />
    </Button>
  );
};

const NextArrow = ({ className, style, onClick }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      className={cx(className, classes.buttonArrow, classes.arrowSurface)}
      // eslint-disable-next-line react/forbid-component-props -- runtime geometry from react-slick
      style={style}
      onClick={onClick}>
      <Feather printType="stroke" type="arrowSlideRight" />
    </Button>
  );
};

const settings = {
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  centerPadding: '30px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
  ],
};

const Slider = ({ title, children, ...props }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      {title && (
        <Typography className={classes.title} variant="h3">
          {title}
        </Typography>
      )}
      <SliderSlick className={classes.slider} {...settings} {...props}>
        {children}
      </SliderSlick>
    </div>
  );
};

export default Slider;
